import { useEffect, useRef } from "react";
import { Button, LoadingSpinner } from "@/components/ui";

export function ReferralResultsLoader({
  hasNextPage,
  isFetching,
  isError,
  fetchNextPage,
}: {
  hasNextPage: boolean;
  isFetching: boolean;
  isError: boolean;
  fetchNextPage: () => Promise<unknown>;
}) {
  const sentinel = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!hasNextPage || isFetching || isError || !sentinel.current) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) void fetchNextPage();
    });
    observer.observe(sentinel.current);
    return () => {
      observer.disconnect();
    };
  }, [hasNextPage, isFetching, isError, fetchNextPage]);
  if (!hasNextPage) return null;
  return (
    <div
      ref={sentinel}
      className="text-muted-foreground flex min-h-12 items-center justify-center gap-2 py-3 text-sm"
    >
      {isError ? (
        <>
          <span>Could not load more results.</span>
          <Button
            variant="outline"
            size="sm"
            onClick={() => void fetchNextPage()}
          >
            Retry
          </Button>
        </>
      ) : (
        <span role="status" className="flex items-center gap-2">
          <LoadingSpinner /> Loading more...
        </span>
      )}
    </div>
  );
}
